import { attr, html, TNode } from '@tempots/dom'

export function H1(...children: TNode[]) {
  return html.h1(
    attr.class(
      'text-3xl sm:text-4xl md:text-5xl font-semibold text-center py-4 sm:py-5 md:py-6 first:pt-0 last:pb-0'
    ),
    ...children
  )
}

export function H2(...children: TNode[]) {
  return html.h2(
    attr.class(
      'text-2xl sm:text-3xl md:text-4xl font-semibold text-center py-4 sm:py-5 md:py-6 first:pt-0 last:pb-0'
    ),
    ...children
  )
}

export function H3(...children: TNode[]) {
  return html.h3(
    attr.class(
      'text-xl sm:text-2xl md:text-3xl font-semibold py-3 sm:py-3.5 md:py-4 first:pt-0 last:pb-0'
    ),
    ...children
  )
}
